/** A region path (`['texas','austin']`) as it appears in a URL: each segment encoded. */
export const pathParam = (path: readonly string[]): string =>
  path.map(encodeURIComponent).join('/');

/** A region's Overview address, from the path on Overview's own row. */
export const overviewHrefFor = (path: readonly string[]): string =>
  `/admin/overview/${pathParam(path)}`;
